module.exports = __webpack_public_path__ + "img/modal_close.f4e101fb.svg";